export default "__VITE_ASSET__122b1139__"